var _defs, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_263",
    "data-name": "Group 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.619,
    height: 123.278,
    viewBox: "0 0 77.619 123.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.091,
    x2: 0.5,
    y2: 1.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0e0e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5953",
    "data-name": "Path 5953",
    d: "M4.566,0H73.054a4.566,4.566,0,0,1,4.566,4.566V118.712a4.566,4.566,0,0,1-4.566,4.566H4.566A4.566,4.566,0,0,1,0,118.712V4.566A4.566,4.566,0,0,1,4.566,0Z",
    transform: "translate(0 0)",
    fill: "#b8b8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5952",
    "data-name": "Path 5952",
    d: "M4.566,0H63.922a4.566,4.566,0,0,1,4.566,4.566V107.3a4.566,4.566,0,0,1-4.566,4.566H4.566A4.566,4.566,0,0,1,0,107.3V4.566A4.566,4.566,0,0,1,4.566,0Z",
    transform: "translate(4.566 4.566)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(27.153 19.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5956",
    "data-name": "Path 5956",
    d: "M2.494,0A2.494,2.494,0,1,1,0,2.494,2.494,2.494,0,0,1,2.494,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5955",
    "data-name": "Path 5955",
    d: "M2.494,0A2.494,2.494,0,1,1,0,2.494,2.494,2.494,0,0,1,2.494,0Z",
    transform: "translate(8.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5954",
    "data-name": "Path 5954",
    d: "M2.494,0A2.494,2.494,0,1,1,0,2.494,2.494,2.494,0,0,1,2.494,0Z",
    transform: "translate(16.624)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorPic);
export default __webpack_public_path__ + "static/media/DoorPic.97ad0f0c7cd25166f6fcf54f2222f973.svg";
export { ForwardRef as ReactComponent };